module.exports = __webpack_public_path__ + "img/Keith_Head.4f186ba5.png";